// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel {
    static getAttributeTypeMap() {
        return UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.attributeTypeMap;
    }
}
UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.discriminator = undefined;
UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "EnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel"
    }
];
//# sourceMappingURL=upsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel.js.map